export default __webpack_public_path__ + "static/media/dgxBanner.fc86344d.jpg";